const API_ENDPOINTS = {
    
    ADMIN_LIST: '/list',

    GENERAL_MASTER_DETAIL: 'general-master/detail/',
    GENERAL_MASTER_LIST: 'general-master/list',
    GENERAL_MASTER_SAVE: 'general-master/save',
    GENERAL_MASTER_DELETE: 'general-master/delete',

    LEADS_DETAIL: 'leads/detail/',
    LEADS_LIST: 'leads/list',
    LEADS_COLOR_WISE_TOTAL: 'leads/color-wise-total',
    LEADS_SAVE: 'leads/save',
    LEADS_SWITCH_COLOR: 'leads/switch-color',
    LEADS_INDIVIDUAL_FIELD: 'leads/individual-field',
    LEADS_REMOVE_UPLOADED_CONTENT: 'leads/update-uploaded-data',
    LEADS_ALREADY_EXIST: 'leads/is-already-exist',
    LEADS_BULK_ALLOTMENT: 'leads/bulk-lead-allotment',
    LEADS_DELETE: 'leads/delete',
    LEADS_COUNTRY_LIST: 'leads/list-countries',
    LEADS_BULK_COLOR_ALLOTMENT: 'leads/bulk-color-allotment',

    TASK_DETAIL: 'task/detail/',
    TASK_LIST: 'task/list',
    TASK_SAVE: 'task/save',
    TASK_TOGGLE_STATUS: 'task/toggle-status',
    TASK_DELETE: 'task/delete',

    ACTIVITY_LIST: 'activity/list',

    DASHBOARD_DETAIL: 'dashboard/detail',
    DASHBOARD_COUNTRYWISE: 'dashboard/country-wise-distribution',
    DASHBOARD_PRODUCTIVITY: 'dashboard/productivity',
    DASHBOARD_TIMESHEET: 'dashboard/timesheet',

    HOLIDAY_LIST: 'holiday/list',
    HOLIDAY_SAVE: 'holiday/save',
    HOLIDAY_DELETE: 'holiday/delete',

    ANNOUNCEMENT_LIST: 'announcement/list',
    ANNOUNCEMENT_SAVE: 'announcement/save',
    ANNOUNCEMENT_DELETE: 'announcement/delete',

    LEAVE_LIST: 'leave/list',
    LEAVE_APPLY: 'leave/apply',
    LEAVE_EDIT: 'leave/edit',
    LEAVE_UPDATE_STATUS: 'leave/update-status',

    TICKET_LIST: 'ticket/list',
    TICKET_DETAIL: 'ticket/detail/',
    TICKET_SAVE: 'ticket/save',
    TICKET_DELETE: 'ticket/delete',
    TICKET_TOGGLE_ITEM: 'ticket/toggle-item',
    TICKET_UPDATE_STATUS: 'ticket/update-status',

    TICKET_COMMENT_LIST: 'ticket-comment/list/',
    TICKET_COMMENT_ADD: 'ticket-comment/add',

    AI_SUGGESTION: 'ai-suggestion/suggest',

    STATUS_START: 'status-log/start',
    STATUS_END: 'status-log/end',
    STATUS_CURRENT: 'status-log/current',
    STATUS_LIST: 'status-log/list',

    GAP_REASON_PENDING: 'gap-reason/pending',
    GAP_REASON_ANSWER: 'gap-reason/answer',
    GAP_REASON_LIST: 'gap-reason/list',

};

export default API_ENDPOINTS;